import { get, post, put, patch } from "../Config"

const apiName = "sustainability-performance-file";

export function SearchInvestorFile({ params = {}, lang }) {
  return get({ url: `/v1/admin/${apiName}`, params, lang })
}
export function GetInvestorFileById({ id, lang }) {
  return get({ url: `/v1/admin/${apiName}/${id}`, lang })
}
export function CreateInvestorFile({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/${apiName}`, params, data, lang })
}
export function UpdateInvestorFile({ params = {}, data = {} , id, lang }) {
  return put({ url: `/v1/admin/${apiName}/${id}`, params, data, lang })
}
export function PatchInvestorFile({ params = {}, data = {} , id, lang }) {
  return patch({ url: `/v1/admin/${apiName}/${id}`, params, data, lang })
}
export function DeleteInvestorFile({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/${apiName}/mutiDelete`, params, data, lang })
}
